var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', [_vm.$vuetify.breakpoint.smAndDown ? _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "temporary": ""
    },
    model: {
      value: _vm.drawer,
      callback: function ($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c('navigation-menu', {
    attrs: {
      "is-mobile": true
    }
  }, [_c('router-view', {
    attrs: {
      "name": "navigation"
    }
  })], 1)], 1) : _vm._e(), !_vm.navbarHidden && _vm.$vuetify.breakpoint.smAndDown ? _c('app-bar-mobile', {
    on: {
      "on-toggle": function ($event) {
        _vm.drawer = !_vm.drawer;
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "app-layout"
  }, [!_vm.navbarHidden && !_vm.$vuetify.breakpoint.smAndDown ? _c('div', {
    staticClass: "navigation-sidebar"
  }, [_c('navigation-menu', [_c('router-view', {
    attrs: {
      "name": "navigation"
    }
  })], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "content-area",
    class: {
      'full-width': _vm.navbarHidden
    }
  }, [_c('v-main', [_c('div', {
    staticClass: "page-flex"
  }, [_c('banner'), _c('div', {
    staticClass: "main-ctn"
  }, [_c('router-view', {
    attrs: {
      "name": "tab"
    }
  })], 1)], 1)])], 1)]), _c('v-snackbar', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (_ref) {
        var attrs = _ref.attrs;
        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "light-blue lighten-2",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.dissmissSnackBar();
            }
          }
        }, 'v-btn', attrs, false), [_vm._v(" " + _vm._s(_vm.$t('dismiss')) + " ")])];
      }
    }]),
    model: {
      value: _vm.snackBar.show,
      callback: function ($$v) {
        _vm.$set(_vm.snackBar, "show", $$v);
      },
      expression: "snackBar.show"
    }
  }, [_vm._v(" " + _vm._s(_vm.snackBar.message) + " ")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }